import { STATUS_LABEL } from '../../constants';
import { useAuth } from '../../store';
import s from '../../styles/dashboard.module.css';

// Draggable staff member card in the sidebar; drag onto a card to assign.
// Only admins can drag (assign); everyone else sees a read-only card.
export function StaffMemberCard({ member }) {
  const { user }    = useAuth();
  const canDrag     = user?.role === 'admin';
  const statusColor = { available: '#6db88a', busy: '#c9956a', break: '#4a4036' };
  const dotColor    = statusColor[member.status] || '#4a4036';
  const memberName  = `${member.given_name || ''} ${member.family_name || ''}`.trim();
  const initials    = memberName.split(' ').filter(Boolean).map(n => n[0]).join('').toUpperCase();

  return (
    <div draggable={canDrag}
         onDragStart={canDrag ? (e => { e.dataTransfer.setData('memberId', member.squareId); e.dataTransfer.effectAllowed = 'copy'; }) : undefined}
         className={s.staffCard}>
      {canDrag && <div className={s.staffDragHandle}>⠿</div>}
      <div className={s.staffInitialBubble}>{initials}</div>
      <div className={s.staffInfo}>
        <div className={s.staffNameText}>{memberName}</div>
        {/* <button onClick={() => onCycleStatus(member.id)} className={s.staffStatusBtn}>
          <div className={s.staffStatusDot} style={{ background: dotColor }} />
          <span className={s.staffStatusText} style={{ color: dotColor }}>{STATUS_LABEL[member.status]}</span>
        </button> */}
      </div>
    </div>
  );
}
